import React from 'react';
import { ImageFile } from '~/data/types/images';

const CarPromotionDoodleAsterisk: React.FC<ImageFile> = ({
  className,
  style,
  Component = 'svg',
}) => {
  return (
    <Component
      className={className}
      style={style}
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="33"
      fill="none"
      viewBox="0 0 32 33"
    >
      <path
        stroke="#00D6D1"
        strokeLinecap="round"
        strokeWidth="3.682"
        d="M12.428 2c1.841 6.203 4.419 20.587 0 28.5"
      ></path>
      <path
        stroke="#00D6D1"
        strokeLinecap="round"
        strokeWidth="3.682"
        d="M2.667 17.85c5.393-1.346 18.344-3.794 27-2.817"
      ></path>
      <path
        stroke="#00D6D1"
        strokeLinecap="round"
        strokeWidth="3.682"
        d="M20.553 3.125c-2.896 6.88-9.844 21.186-14.476 23.376"
      ></path>
      <path
        stroke="#00D6D1"
        strokeLinecap="round"
        strokeWidth="3.682"
        d="M5.432 8.082c3.448 1.898 11.04 7.245 13.825 13.45"
      ></path>
    </Component>
  );
};

export default CarPromotionDoodleAsterisk;
